import useReview from '@hooks/useReview';
import { useSelector } from '@store';
import PaymentBubble from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function TransactionCompletedBubble({
  chatMessage,
  partnerProfileId
}: PaymentBubbleCommonProps) {
  const { onUpdateReview } = useReview();
  const rfqId = useSelector((state) => state.chat?.rfqId ?? '');
  const hasReview = useSelector((state) => state.chat?.hasReview ?? false);
  const quotationPartnerId = useSelector(
    (state) => state.chat?.quotationPartnerId ?? ''
  );

  const companyName = chatMessage?.rfq?.partnerOrganizationName ?? '';

  const onClickButton = () => {
    onUpdateReview({
      open: true,
      organizationName: companyName,
      profileId: partnerProfileId ?? '',
      projectName: chatMessage?.rfq?.projectName ?? '',
      quotationPartnerId,
      rfqId,
      reviewId: ''
    });
  };

  return (
    <PaymentBubble>
      <PaymentBubble.Title>거래가 완료되었습니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={4} />
      <PaymentBubble.Content>
        파트너와의 거래는 어떠셨나요? 고객님의 소중한 후기를 작성해주세요.
      </PaymentBubble.Content>
      <PaymentBubble.Button disabled={hasReview} buttonAction={onClickButton}>
        리뷰작성
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
